export type HomeRedirectProject = {
  id: number
  created_at?: string
  environment_count?: number
}

/**
 * Destination for `/`. Always a real route — never stay on `/`.
 * Before the project list is known, send people to `/projects` (its own loader).
 */
export function homeRedirectPath(
  projects: HomeRedirectProject[],
  hasFetched: boolean,
  canCreateProject = true,
): string {
  if (!hasFetched) return '/projects'
  if (projects.length === 0) return canCreateProject ? '/projects/new' : '/projects'
  if (projects.some((p) => (p.environment_count ?? 0) > 0)) return '/projects'
  const newest = [...projects].sort((a, b) => {
    const ta = a.created_at ? Date.parse(a.created_at) : 0
    const tb = b.created_at ? Date.parse(b.created_at) : 0
    return tb - ta
  })[0]
  return newest ? `/project/${newest.id}` : '/projects'
}

export function withLocationSuffix(path: string, search = '', hash = ''): string {
  return `${path}${search}${hash}`
}
